import { AlertTriangle, ExternalLink } from "lucide-react";
import { useInstatusStatusQuery } from "@/hooks/queries/instatus/useInstatusStatusQuery";

export function InstatusOutageBanner() {
  const { data } = useInstatusStatusQuery();

  if (!data?.visible) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full border-b border-warning-border bg-warning text-warning-foreground"
    >
      <div className="flex min-w-0 items-start gap-3 px-4 py-2.5">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">{data.title}</p>
          <p className="text-sm">{data.message}</p>
        </div>
        {data.href && (
          <a
            href={data.href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex h-7 shrink-0 self-center items-center justify-center gap-1 rounded-md text-[0.8rem] font-semibold text-inherit underline-offset-4 transition-colors hover:underline"
          >
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
            View updates
          </a>
        )}
      </div>
    </div>
  );
}
